const ClaimantData = ({
  Name,
  Document,
}) => ({
  name: Name ?? '',
  document: Document ?? '',
})

export default ClaimantData
